export default __webpack_public_path__ + "img/orange-arrow-up.35aa9467.svg";